import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-date-cell',
  templateUrl: './date-cell.component.html',
  styleUrls: ['./date-cell.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzModalModule
  ]
})
export class DateCellComponent implements OnInit {
  @Input()
  value!: Date;

  @Output()
  valueUpdated = new EventEmitter<Date>;

  isVisible = false;

  valueForm = new FormGroup({
    value: new FormControl()
  });

  constructor() {
  }

  ngOnInit(): void {
    this.valueForm.patchValue({ value: this.value });
  }

  handleCancel() {
    this.isVisible = false;
  }

  handleOk() {
    this.value = this.valueForm.value.value;
    this.isVisible = false;
    this.valueUpdated.emit(this.value);
  }

  showDialog() {
    this.isVisible = true;
  }

}
